import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';

import { AccountPages } from '../../../constants/AppConstants';
import ModalActions from '../../../actions/ModalActions';
import t from '../../../lib/I18n';

import BaseModal from '../../general/BaseModal';
import FormattedHTMLMessage from '../../general/FormattedHTMLMessage';
import Link from '../../general/Link';

export default function PromptModal () {
    const footer = (
        <div>
            <Link to={ AccountPages.ACCOUNT_PREFERENCE_CENTRE } onClick={ () => ModalActions.close(PromptModal) }>
                <Button bsStyle='primary' className='pull-right'>
                    { t('preference-centre.prompt-modal.continue-text') }
                </Button>
            </Link>
        </div>
    );

    const modalProps = {
        className: 'modal--xs',
        titleText: 'preference-centre.prompt-modal.title',
        disableEscape: true,
        footer
    };
    return (
        <BaseModal { ...modalProps }>
            <FormattedHTMLMessage message='preference-centre.prompt-modal.text' splitParagraphs />
        </BaseModal>
    );
}

PromptModal.contextTypes = {
    router: PropTypes.shape({
        push: PropTypes.func
    })
};
